import RoundedCard from "./RoundedCard"

const MyFanDomItemSkeleton = () => {
  return (
    <RoundedCard>
      <div className="flex w-[225px] h-[86px] p-4 gap-3">
        {/* 아이콘 영역 스켈레톤 */}
        <div className="animate-pulse bg-gray-300 w-[54px] h-[54px] shrink-0 rounded-[14px]" />
        {/* 텍스트 영역 스켈레톤 */}
        <div className="flex flex-col justify-center gap-1">
          <div className="animate-pulse bg-gray-300 w-8 h-3 rounded" />
          <div className="animate-pulse bg-gray-300 w-20 h-4 rounded" />
        </div>
      </div>
    </RoundedCard>
  );
}

export default MyFanDomItemSkeleton